var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"part part6"},[_c('div',{staticClass:"font-size__36px"},[_vm._v(" "+_vm._s(_vm.$t(`guanwang1.us30`))+" ")]),_c('div',{staticClass:"part6-earth"},[_c('img',{attrs:{"src":_vm.EarthGif,"alt":""}})]),_c('div',{staticClass:"part6-content"},[_c('call-us')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }